import React from "react";
import { connect } from 'react-redux';

import { withStyles } from '@mui/styles';

import CommonStyles from "../../common/CommonStyles";
import ComponentWrapper from "../../common/ComponentWrapper";
import ViewAccessRule from "../../common/ViewAccessRule";
import Node from "../../common/Node";

import { getNodesIdsFromGraphTrigger } from "../../utils";

const styles = {
  ...CommonStyles,
};

class AccessRulesPage extends ComponentWrapper {
  state = {
    accessRules: [],
    accessRulesNodes: {},
  };

  componentDidMount() {
    this.getAllAccessRules();
  };

  getAllAccessRules = () => {
    this.get({
      url: `/rest/get_access_rules`,
      cb: (res) => {
        if (res.access_rules) {
          this.setState({
            accessRules: res.access_rules.reverse(),
          })
          if (res.access_rules.length) this.collectNodeIdsFromGraphTriggers(res.access_rules);
        }
      }
    });
  };

  collectNodeIdsFromGraphTriggers = (accessRules) => {
    const { setup, setup_rbox_light } = this.props;

    const nodesIds = getNodesIdsFromGraphTrigger(accessRules, setup_rbox_light);

    const data = {
      api_key: setup.id,
      nesting: 2,
      filter: {
        nodes: nodesIds,
        page: 1,
        limit: 100,
      },
      sorter: {
        sort_pid: '',
        sort_by: '',
      },
    };

    this.postWithData({
      url: `/pnkqry3`,
      data,
      cb: (data) => {
        if (data.nodes) this.setState({ accessRulesNodes: data.nodes });
      }
    });
  };

  render() {
    const { accessRules, accessRulesNodes } = this.state;
    const { setup_rbox_light, classes, jels, accounts_tbox } = this.props;

    const rulesWithNoAccountCategory = accessRules.length && accessRules.filter(rule => !rule.categories);

    return (
      <div>
        {accounts_tbox.nodes && Object.values(accounts_tbox.nodes).map((accountNode, index) => {
          const rulesByAccount = accessRules.filter(rule => rule.categories && rule.categories[0] === accountNode.id);

          if (!rulesByAccount.length) return null;

          return (
            <React.Fragment key={accountNode.id}>
              <div className={classes.mt20} style={{ marginLeft: '5px' }}>
                <Node
                  size="md"
                  nodeId={accountNode.id}
                  node={accountNode}
                />
              </div>
              <div>
                {rulesByAccount.length ?
                  rulesByAccount.map((rule, index) => {
                    return (
                      <div key={rule.id}>
                        <ViewAccessRule
                          // updateAccessRule={this.updateAccessRule}
                          // getRulesInitials={this.getRulesInitials}
                          //addNodeToNodesData={addNodeToNodesData}
                          accessRulesNodes={accessRulesNodes}
                          //deleteAccessRule={deleteAccessRule}
                          setup_tbox={setup_rbox_light}
                          key={rule['id']}
                          ruleIndex={index}
                          ruleData={rule}
                          jels={jels}
                        />
                      </div>
                    )
                  })
                : null}
              </div>
            </React.Fragment>
          )
        })}

        {rulesWithNoAccountCategory && rulesWithNoAccountCategory.length ? (
          <div className={`${classes.mt20}`}>
            <span className={`${classes.ml10}`} style={{ color: '#4c4c4c' }}>Access rule with no user category</span>
            {rulesWithNoAccountCategory.map((rule, index) => {
              return (
                <div key={index}>
                  <ViewAccessRule
                    // updateAccessRule={this.updateAccessRule}
                    // getRulesInitials={this.getRulesInitials}
                    //addNodeToNodesData={addNodeToNodesData}
                    accessRulesNodes={accessRulesNodes}
                    //deleteAccessRule={deleteAccessRule}
                    setup_tbox={setup_rbox_light}
                    key={rule['id']}
                    ruleIndex={index}
                    ruleData={rule}
                    jels={jels}
                  />
                </div>
              )
            })}
          </div>
        ) : null}
      </div>
    )
  }
}

export default connect((state) => ({
  jels: state.jels,
  setup: state.meta.setup,
  accounts_tbox: state.meta.accounts_tbox,
  setup_rbox_light: state.meta.light_meta_and_ops.setup_rbox_light,
 }),
{ })(withStyles(styles)(AccessRulesPage));
